import PropTypes from 'prop-types';
import PageCard from '../PageCard';
import classNames from 'classnames';
import styles from './PageCardList.module.scss';

const PageCardList = ({ items = [] }) => {
    return (
        <div className={styles['PageCardList']}>
            <div className={styles['PageCardList__List']}>
                {items.map((item, i) => (
                    <div
                        key={i}
                        className={styles['PageCardList__Item']}
                    >
                        <PageCard {...item} />
                    </div>
                ))}
            </div>
        </div>
    )
};

PageCardList.propTypes = {
    items: PropTypes.array
};

export default PageCardList;
